var e = /* @__PURE__ */ ((r) => (r.Keyboard = "keyboard", r))(e || {});
const t = {
  Default: 1,
  Shift: 3
};
export {
  e as EventsEnum,
  t as Multipliers
};
